import React, { useState, useEffect } from 'react';
import { ButtonComponent, CustomDatePicker, Studentdatetime ,TimePickerModal } from 'tutorapp-components';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {  setSchoolDate, setSchoolTime ,setSchoolDuration} from '../redux/actions/schoolPresetValuesActions';
import { createSchoolAppointmentRequest } from '../redux/actions/schoolAppointmentActions';

export default function SchooldatetimeScreen() {
  
  const moment = require('moment-timezone');
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userPreferences = useSelector((state) => state.userPreferences);
  const schoolDate = useSelector(state => state.schoolPresetValues.schoolDate);
  const schoolTime = useSelector(state => state.schoolPresetValues.schoolTime);
  const schoolDuration = useSelector(state => state.schoolPresetValues.schoolDuration);


  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState({ start: '', end: '' });
  const [duration, setDuration] = useState('');

  // Duration options (15 min to 12 hours in 15-min increments)
  const durationOptions = Array.from({ length: 48 }, (_, i) => {
    const totalMinutes = (i + 1) * 15;
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    const label =
      hours > 0
        ? `${hours} hour${hours > 1 ? 's' : ''}${minutes > 0 ? ` ${minutes} min${minutes > 1 ? 's' : ''}` : ''}`
        : `${minutes} mins`;
    return { value: totalMinutes, label };
  });

  const formatTime = (time) => {
    return time ? `${time}:00` : '';
  };

  const formatDate = (date) => {
    const d = new Date(date);
    return d.toISOString().split('T')[0];
  };

  // Calculate end time based on start time and duration
  const calculateEndTime = (startTime, durationMinutes) => {
    if (!startTime || !durationMinutes) return '';
    const match = startTime.match(/^(\d{2}:\d{2})$/);
    if (!match) return '';

    const start = moment(startTime, 'HH:mm');
    const end = start.clone().add(durationMinutes, 'minutes');
    return end.format('HH:mm');
  };

  const handleTimeSelection = (time) => {
    const newTime = {
      start: time,
      end: calculateEndTime(time, duration)
    };
    setSelectedTime(newTime);
  };

  const handleDurationChange = (e) => {
    const newDuration = Number(e.target.value);
    setDuration(newDuration);
     dispatch(setSchoolDuration(newDuration))
    if (selectedTime.start) {
      const newEndTime = calculateEndTime(selectedTime.start, newDuration);
      setSelectedTime({ ...selectedTime, end: newEndTime });
    }
  };

  const handleContinue = () => {
    const datetime = {
      appointment_start_time: formatTime(selectedTime.start),
      appointment_date: formatDate(selectedDate),
      appointment_end_time: formatTime(selectedTime.end)
    };
    dispatch(createSchoolAppointmentRequest(datetime));
    dispatch(setSchoolDate(selectedDate));
    dispatch(setSchoolTime(selectedTime));
    navigate('/school-setup');
  };

  const handleBack = () => {
    navigate('/schoolfilldetails');
  };

  const handleSelectionClose = () => {
    navigate('/MyAppointment');
  };

  useEffect(() => {
    if (schoolDate) {
      setSelectedDate(schoolDate);
    }
    if (schoolTime) {
      setSelectedTime(schoolTime);
    }
     if (schoolDuration) {
    setDuration(schoolDuration);
  }
  }, [schoolDate, schoolTime , schoolDuration]);

  // Check if all required values are selected
  const isContinueDisabled = !selectedDate || !selectedTime.start || !selectedTime.end || !duration;

  const icons = {
    backarrow: './images/ic_back.svg',
    address: './images/ic_tutoring_address.svg',
    repeat: './images/ic_repeat.svg',
    sessionappointment: './images/ic_sessionappointment.svg',
    close: './images/ic_close.svg',
    progress: './images/ic_3.svg',
  };

  return (
    <div>
      <Studentdatetime icons={icons} handleselectionclose={handleSelectionClose} />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginBottom: '5px',
          fontFamily: 'GT-Walsheim',
        }}
      >
        <div className="mb-2 mt-3" style={{ width: '325px' }}>
          <label
            className="d-block text-start mb-2"
            style={{ fontSize: 15, color: '#0b1422', fontFamily: 'GT-Walsheim-Medium' }}
          >
            Start Date
          </label>
          <CustomDatePicker
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            userPreferences={userPreferences}
          />
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginBottom: '25px',
          fontFamily: 'GT-Walsheim',
        }}
      >
        <div className="mb-2" style={{ width: '325px', fontFamily: 'GT-Walsheim' }}>
          <label
            className="d-block text-start mb-2"
            style={{ fontSize: 15, color: '#0b1422', fontFamily: 'GT-Walsheim-Medium' }}
          >
            Start Time
          </label>
          <TimePickerModal
            onTimeSelect={handleTimeSelection}
            defaultStartTime={selectedTime.start}
            userPreferences={userPreferences}
             icons= { {
              time: './images/ic_time.svg',
                 down: './images/ic_down.svg',}}
          />
        </div>

        <div className="mb-2" style={{ width: '325px', fontFamily: 'GT-Walsheim' }}>
          <label
            className="d-block text-start mb-2"
            style={{ fontSize: 15, color: '#0b1422', fontFamily: 'GT-Walsheim-Medium' }}
          >
            Duration
          </label>
          <select
            value={duration}
            onChange={handleDurationChange}
            className="form-control text-center"
            style={{ height: '45px', fontFamily: 'GT-Walsheim', color: 'black' }}
          >
            <option value="" disabled>
              Select duration
            </option>
            {durationOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginTop: '55px',
          fontFamily: 'GT-Walsheim',
        }}
      >
        <div style={{ width: '330px', marginBottom: 10, fontFamily: 'GT-Walsheim' }}>
          <ButtonComponent
            onPress={isContinueDisabled ? null : handleContinue}
            label="Continue"
            disabled={isContinueDisabled}
            style={{
              backgroundColor: isContinueDisabled ? '#ccc' : '#000',
              paddingVertical: 12,
              fontFamily: 'GT-Walsheim',
              pointerEvents: isContinueDisabled ? 'none' : 'auto',
            }}
            textStyle={{
              color: isContinueDisabled ? '#666' : '#fff',
              fontFamily: 'GT-Walsheim',
            }}
          />
        </div>

        <div style={{ width: '330px', fontFamily: 'GT-Walsheim' }}>
          <ButtonComponent
            onPress={handleBack}
            label="Back"
            style={{ backgroundColor: '#E9EDF1', paddingVertical: 12, fontFamily: 'GT-Walsheim' }}
            textStyle={{ color: '#000', fontFamily: 'GT-Walsheim' }}
          />
        </div>
      </div>
    </div>
  );
}